import { observer } from 'mobx-react';
import React from 'react';
import PopoverButton from '../../../App/Components/PopoverButton';
import { AppService, Types } from "../../../Services/AppService";
import InvestorLinkedPortfolioLookup from '../../../Models/Investors/InvestorLinkedPortfolioLookup';
import AppLayout from '../../../Services/AppLayout';
import LinkedInvestorLookup from '../../../Models/Investors/LinkedInvestorLookup';
import Dashboard from '../Dashboard';
import InvestorProfileView from '../../Investor/InvestorProfileView';

interface IInvestmentSelectionComponentProps {
    hideInvestmentType?: boolean;
}

@observer
export default class InvestmentSelectionComponent extends React.Component<IInvestmentSelectionComponentProps> {

    private investorService = AppService.get(Types.Services.CurrentInvestorService);
    private navigation = AppService.get(Types.Neo.Routing.NavigationHelper);

    private onPortfolioClick(portfolio: InvestorLinkedPortfolioLookup) {
        this.investorService.investorData!.selectedPortfolio = portfolio;
        AppLayout.globalTaskRunner!.waitFor(this.investorService.getPortfolioAsync());
    }

    private async onLinkedInvestorClick(linkedInvestor: LinkedInvestorLookup) {   
        // Fetch the linked investor's data (e.g., portfolios, account details)
        await AppLayout.globalTaskRunner!.waitFor(this.investorService.selectInvestor(linkedInvestor.investorID));
        
        // If the selected linked investor is ready to invest, navigate to the Dashboard. Otherwise, redirect them to the Investor Profile view to complete their profile.
        if (this.investorService.investorData!.readyToInvest) {
            this.navigation.navigateToView(Dashboard);
        } else {
            this.navigation.navigateToView(InvestorProfileView);
        }
    }

    public render() {
        let investorData = this.investorService.investorData,
            investorInfo = investorData?.investor,
            linkedInvestors = this.investorService.linkedInvestors.map(l => ({ text: l.firstName + ' ' + l.surname, onClick: () => this.onLinkedInvestorClick(l) }));

        if (linkedInvestors.length === 0) {
            linkedInvestors = [{ text: "No other linked accounts found.", onClick: () => Promise.resolve() }];
        }

        return investorInfo && (
            <div className="investor-selection-component">
                <div className="investor-type-heading">
                    <div className="investor-type">
                        <h4>{investorInfo.investorType} Account</h4>
                        <PopoverButton menuItems={linkedInvestors}  />
                    </div>
                    <div className="sub-text">
                        {investorInfo.fullName}
                    </div>
                </div>
                {!this.props.hideInvestmentType && <div className="investment-type-heading">
                    <div>
                        <h4>Investment Type</h4>
                        <PopoverButton menuItems={ investorInfo.portfolioList.map(p => ({ text: p.portfolioType, onClick: () => this.onPortfolioClick(p) }))} />
                    </div>
                    <div className="sub-text">
                        {investorData!.selectedPortfolio?.portfolioType ?? ""}
                    </div>
                </div>}
            </div>
        )
    }
}